var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { windowStage } from './StageEnum';
/**
 * @hidden
 */
var WindowTitleBarComponent = function (props) {
    var children = props.children, onCloseButtonClick = props.onCloseButtonClick, onMinimizeButtonClick = props.onMinimizeButtonClick, onFullScreenButtonClick = props.onFullScreenButtonClick, onRestoreButtonClick = props.onRestoreButtonClick, onDoubleClick = props.onDoubleClick, stage = props.stage, forwardedRef = props.forwardedRef;
    var minimizeButtonRender = props.minimizeButton ?
        React.createElement(props.minimizeButton, { onClick: onMinimizeButtonClick, stage: stage }) :
        (React.createElement("button", { className: "k-button-icon k-button k-flat", onClick: onMinimizeButtonClick },
            React.createElement("span", { className: "k-icon k-i-window-minimize", role: "presentation" })));
    var maximizeButtonRender = props.maximizeButton ?
        React.createElement(props.maximizeButton, { onClick: onFullScreenButtonClick, stage: stage }) :
        (React.createElement("button", { className: "k-button-icon k-button k-flat", onClick: onFullScreenButtonClick },
            React.createElement("span", { className: "k-icon k-i-window-maximize", role: "presentation" })));
    var restoreButtonRender = props.restoreButton ?
        React.createElement(props.restoreButton, { onClick: onRestoreButtonClick, stage: stage }) :
        (React.createElement("button", { className: "k-button-icon k-button k-flat", onClick: onRestoreButtonClick },
            React.createElement("span", { className: "k-icon k-i-window-restore", role: "presentation" })));
    var closeButtonRender = props.closeButton ?
        React.createElement(props.closeButton, { onClick: onCloseButtonClick, stage: stage }) :
        (React.createElement("button", { className: "k-button-icon k-button k-flat", onClick: onCloseButtonClick },
            React.createElement("span", { className: "k-icon k-i-close", role: "presentation" })));
    return (React.createElement("div", { className: "k-window-titlebar k-dialog-titlebar", style: { touchAction: 'none' }, ref: forwardedRef, onDoubleClick: onDoubleClick },
        React.createElement("div", { className: "k-window-title" }, children ? children : ''),
        React.createElement("div", { className: "k-window-actions" },
            (stage === windowStage.DEFAULT) && minimizeButtonRender,
            (stage === windowStage.DEFAULT) && maximizeButtonRender,
            (stage !== windowStage.DEFAULT) && restoreButtonRender),
        closeButtonRender));
};
/**
 * @hidden
 */
export var WindowTitleBar = React.forwardRef(function (props, ref) { return (React.createElement(WindowTitleBarComponent, __assign({}, props, { forwardedRef: ref }))); });
//# sourceMappingURL=WindowTitlebar.js.map